export const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1)

export const calculateCp = (
    base_attack: number,
    attackIv: number,
    base_defense: number,
    defenseIv: number,
    base_stamina: number,
    staminaIv: number,
    cpMultiplier: number
    ) => {
    return Math.floor((base_attack + attackIv) * Math.sqrt(base_defense + defenseIv) * Math.sqrt(base_stamina + staminaIv) * Math.pow(cpMultiplier, 2) / 10)
}

export const outerHeight = (element: HTMLElement | null) => {
    if (!element) {
        return 0
    }
    const height = element.offsetHeight,
        style = window.getComputedStyle(element)

    return ['top', 'bottom']
        .map(side => parseInt(style[`margin-${side}`]))
        .reduce((total, side) => total + side, height)
}